const state = {
    // 編輯/瀏覽模式
    lang: 'cn',
    overlay: false,
    langList: [
        { id: 1, text: '中文', key: 'cn' },
        { id: 2, text: 'EN', key: 'en' }
    ],
    modifyMode: { show: false },
    dialog: {
        show: false,
        name: '',
        maxWidth: ''
    },
    publicPath: process.env.BASE_URL,
    menuItems: [
        {
            key: 'MENU_1',
            link: '/',
            permission: false
        },
        {
            key: 'MENU_2',
            link: '/document',
            permission: true
        }
    ]
};
export default {
    namespaced: true,
    state,
    mutations: {
        SetLoading(state, data) {
            if (state.overlay !== data) {
                state.overlay = data;
            }
        },
        ChangeState(state, obj) {
            state[obj.key] = obj.val;
        },
        ChangeLoginUserMode(state, mode) {
            const { show } = state.modifyMode;
            const timeout = show ? 800 : 0;
            state.modifyMode.show = false;
            state.modifyMode.width = 0;
            const data = {
                show: mode[0],
                width: '32%'
            };
            if (mode[1]) {
                data.width = mode[1];
            }
            setTimeout(() => { state.modifyMode = data; }, timeout);
        },
        ChangeDialog(state, name) {
            const show = name !== '';
            let width = '500px';
            switch (name) {
                case 'Source':
                    width = '800px';
                    break;
                case 'Logout':
                    width = '600px';
                    break;
            }
            state.dialog.show = show;
            state.dialog.name = name;
            state.dialog.maxWidth = width;
        }
    },
    actions: {}
};
